import { waitForWindowVariable } from "common/utils/ui/wait_for";
import { waitForMixpanelReady } from "common/utils/mixpanel/wait-for-mixpanel";
import trackRudderstackEvent from "./track-rudderstack-event";

const delayedEvents = [];

// window.rudderanalytics is already available, retrySubmitRudderstackEvents
// will not be called
const retrySubmitRudderstackEvents = (event, properties, sendToMixpanel = false) => {
  if (!delayedEvents.length) {
    waitForWindowVariable("rudderanalytics", () => {
      // eslint-disable-next-line no-console
      if (window.ANALYTICS_LOGS_ENABLED) {
        console.log(`Found ${delayedEvents.length} rudderstack event(s) from bucket to submit`);
      }

      const flush = () => {
        while (delayedEvents.length > 0) {
          const [e, prop, sendToMp] = delayedEvents.shift();
          trackRudderstackEvent(e, prop, sendToMp);
        }
      };

      const needsMixpanel = delayedEvents.some(([, , sendToMp]) => sendToMp);
      if (needsMixpanel) {
        waitForMixpanelReady(flush);
      } else {
        flush();
      }
    });
  }

  delayedEvents.push([event, properties, sendToMixpanel]);
};

export default retrySubmitRudderstackEvents;
